export const SAVE_QUOTES_LIST = 'SAVE_QUOTES_LIST'; 
export const SAVE_QUOTE_DETAILS = 'SAVE_QUOTE_DETAILS'; 